import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-date-time-picker', {
    mixins: [FormElementMixin],
    props: {
        position: {
            type: Object,
        }
    },
    data() {
        return {
            removeFromListener: ['input','updateState','blur'],
            selectedDate: null,
            selectedTime: null,
            dateFormat: 'DD/MM/YYYY',
            timeFormat: 'HH:mm',
            timeMask: [/[0-2]/,/[0-9]/,':',/[0-5]/,/[0-9]/]
        }
    },
    watch: {
        selectedDate(newValue) {
            if(this.$moment(this.currentValue).format(this.dateFormat) !== this.$moment(newValue).format(this.dateFormat)) {
                this.dateChanged();
            }
        },
        selectedTime(newValue) {
            const currentValueFormatted = this.currentValue ? this.$moment(this.currentValue).format(this.timeFormat) : null;
            const newValueFormatted = newValue ? newValue : null;
            if(currentValueFormatted !== newValueFormatted) {
                this.dateChanged();
            }
        },
        currentValue(newValue) {
            if (! newValue) {
                this.selectedDate = null;
                this.selectedTime = null;
                return;
            }

            if(this.$moment(newValue).format(this.dateFormat) !== this.$moment(this.selectedDate).format(this.dateFormat)) {
                this.selectedDate = this.$moment(this.currentValue).toDate();
            }

            if(this.selectedTime && this.selectedTime.length === 5 && this.$moment(newValue).format(this.timeFormat) !== this.$moment(this.selectedTime).format(this.timeFormat)) {
                this.selectedTime = this.$moment(this.currentValue).format(this.timeFormat);
            }
        }
    },
    methods: {
        dateChanged() {
            // if no time is set we set default to 00:00
            if (!this.selectedTime && this.selectedDate) {
                this.currentValue = this.$moment(
                        this.$moment(this.selectedDate).format(this.dateFormat) + ' ' + this.$moment('00:00', 'HH:mm').format(this.timeFormat),
                        this.dateFormat + ' ' + this.timeFormat);
            }

            if(this.$moment(this.selectedTime, 'HH:mm').isValid()) {
                this.currentValue = this.$moment(
                        this.$moment(this.selectedDate).format(this.dateFormat) + ' ' + this.selectedTime,
                        this.dateFormat + ' ' + this.timeFormat
                ).toISOString(true);
            }

            this.blur();
        },
        clearTime() {
            this.selectedDate = null;
            this.selectedTime = null;
            this.currentValue = null;
        }
    },
    created() {
        if(this.currentValue) {
            this.selectedDate = this.$moment(this.currentValue).toDate();
            this.selectedTime = this.$moment(this.currentValue).format(this.timeFormat);
        }
    }
}, 'form/controls/ak-date-time-picker.html');
